<template>
    <div class="photo-album">
        <post-back :title="photoAlbum && photoAlbum.title" :background="photoAlbum.photos[0].src" />
        <div class="container">
            <br />
            <div class="row no-gutters">
                <div class="col-sm-4 col-md-3 " :key="i" v-for="(photo,i) in photoAlbum.photos">
                    <div class="photo" :style="{backgroundImage:`url(${photo.src}?w=350)`}" @click="openPhoto(i)">
                        <img class="stretch" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7">
                        <div class="title">
                            {{photo &&photo.title || "Без названия"}}
                        </div>
                    </div>
                </div>
            </div>
            <br />
        </div>
    </div>
</template>
<script>
import _ from "lodash";
export default {

    name: 'photo-album',
    methods: {
        openPhoto(index) {
            this.$store.commit('openPhoto', { list: this.photoAlbum.photos, index });
        }
    },
    data() {
        return {

        }
    },
    computed: {
        photoAlbum() {
            let { list } = this.$store.state.albums;
            return _(list).keyBy('_id').value()[this.$route.params.id];
        }
    }
}
</script>
<style lang="css" scoped>
.photo {
    background-size: cover;
    background-position: center;
    margin: 5px;
    transition: 0.2s all ease;
    cursor: pointer;
    overflow: hidden;

    transform: scale(1.0);
}

.photo:hover {
    transform: scale(1.05);
}

.photo:hover .title {
    margin-top: -26px;

}

.title {
    background: rgba(0, 0, 0, 0.8);
    color: white;
    padding: 6px;
    position: absolute;
    margin-top: 0px;
    width: 100%;
    transition: 0.3s all ease;
}
</style>